/* PRD-037 — Componentes de gestion compartidos (V4). */
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import type { PartnerCommerce } from '@services/partnerService';
import { Badge, C } from './ui';
import { fmtDate } from './useCommerces';

export const Stat = ({ label, value, tone }: { label: string; value: ReactNode; tone?: string }) => (
  <div
    style={{
      flex: 1,
      background: C.white,
      border: `1px solid ${C.cardBorder}`,
      borderRadius: 12,
      padding: '16px 18px',
    }}
  >
    <div style={{ fontSize: 26, fontWeight: 700, color: tone || C.primary, lineHeight: 1.1 }}>{value}</div>
    <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>{label}</div>
  </div>
);

export const CommerceItem = ({ c, actions }: { c: PartnerCommerce; actions?: ReactNode }) => {
  const navigate = useNavigate();
  const claimed = c.estado === 'reclamado';
  return (
    <div
      style={{
        borderTop: `1px solid ${C.cardBorder}`,
        padding: '14px 0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
      }}
    >
      <button
        type="button"
        onClick={() => c.id_comercio && navigate(`/partner/comercios/${c.id_comercio}`)}
        style={{
          textAlign: 'left',
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          minWidth: 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 600, fontSize: 15, color: C.primary }}>
            {c.negocio_nombre || 'Comercio sin nombre'}
          </span>
          <Badge tone={claimed ? 'claimed' : 'draft'}>{claimed ? 'Reclamado' : 'Borrador'}</Badge>
        </div>
        <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>
          {c.owner_nombre || 'Sin dueno'}
          {c.owner_telefono ? ` · ${c.owner_telefono}` : ''}
          {c.owner_correo ? ` · ${c.owner_correo}` : ''}
        </div>
        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>
          {c.tipo_plan || 'FREEMIUM'}
          {c.created_at ? ` · creado ${fmtDate(c.created_at)}` : ''}
        </div>
      </button>
      {actions ? <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>{actions}</div> : null}
    </div>
  );
};
